import * as React from 'react';
import type { ClickableItemListProps } from '@components/molecules';
import { ClickableList } from '@components/molecules';
import { CardPrimaryLayout } from '@components/organisms';

interface ClickableListCardProps extends ClickableItemListProps {
	title: string;
}

const ClickableListCard = React.forwardRef<HTMLUListElement, ClickableListCardProps>(({ rows, title }, ref) => (
	<span data-aid="clickable-list-card">
		<CardPrimaryLayout title={title} className="h-full">
			<ClickableList rows={rows} ref={ref} />
		</CardPrimaryLayout>
	</span>
));

ClickableListCard.displayName = 'ClickableListCard';

export { ClickableListCard };
